export default "__VITE_ASSET__CBjib5jc__"